import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, number, shape, string } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { faThermometerThreeQuarters } from "@fortawesome/pro-regular-svg-icons";
import { DateTime } from "luxon";

RecurringGift.propTypes = {
  gift: shape({
    firstName: string,
    lastName: string,
    amount: string,
    interval: string,
    endDate: string,
    nextPaymentDate: string,
    forActivePledge: bool,
  }),
  i: number,
};

export default function RecurringGift({ gift, i }) {
  const endingSoon = () => {
    let now = new DateTime.now();
    let endDate = new DateTime.fromISO(gift.endDate);
    let oneMonthAway = now.plus({ months: 1 });
    return endDate.startOf("day") < oneMonthAway.startOf("day");
  };

  const nextPayment = gift?.nextPaymentDate
    ? DateTime.fromISO(gift.nextPaymentDate).toFormat("MMM d")
    : null;
  const endDate = DateTime.fromISO(gift.endDate).toFormat("MMM d");

  return (
    <Gift
      $i={i}
      onClick={() => window.fnReactBus.loadUserGivingProfile(gift.userID)}
    >
      <Name data-cy="recurringGiftName">
        {gift?.firstName} {gift?.lastName}
      </Name>

      <Details>
        <Amount data-cy="recurringGiftAmount">
          {gift?.forActivePledge ? (
            <FontAwesomeIcon
              icon={faThermometerThreeQuarters}
              size="sm"
              style={{ marginRight: "4px" }}
            />
          ) : null}
          {gift?.amount}/{gift?.interval}
        </Amount>
        {nextPayment ? (
          <PaymentInfo data-cy="recurringNextPayment">
            Next: {nextPayment}
          </PaymentInfo>
        ) : null}
        <PaymentInfo>{endingSoon() ? `Ends: ${endDate}` : null}</PaymentInfo>
      </Details>
    </Gift>
  );
}

const Gift = styled.div`
  background-color: ${(props) =>
    props.$i % 2 === 1 ? "hsl(0 0% 95%)" : "white"};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  font-weight: 400;

  &:hover {
    cursor: pointer;
  }
`;

const Name = styled.div`
  flex-grow: 1;
  width: max-content;
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;
const Amount = styled.div`
  display: flex;
  align-items: center;
`;
const PaymentInfo = styled.div`
  color: #828c8d;
  font-size: 12px;
`;
